import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import feedbackTheme from "../../theme/feedback";

const PALETTE = {
  pending: { bg: feedbackTheme.color.infoBg, color: feedbackTheme.color.info },
  late: { bg: feedbackTheme.color.errorBg, color: feedbackTheme.color.error },
  late_today: {
    bg: feedbackTheme.color.warningBg,
    color: feedbackTheme.color.warning,
  },
  waiting_pickup: {
    bg: feedbackTheme.color.surfaceAlt,
    color: feedbackTheme.color.primary,
  },
  complete: {
    bg: feedbackTheme.color.successBg,
    color: feedbackTheme.color.success,
  },
};

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
  white-space: nowrap;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$color};
`;

export const JobStatusBadge = ({ status, className }) => {
  const { t } = useTranslation();
  const key = (status || "").toLowerCase();
  const palette = PALETTE[key] || PALETTE.pending;
  return (
    <Pill $bg={palette.bg} $color={palette.color} className={className}>
      {t(`jobBoard.${key}`)}
    </Pill>
  );
};

export default JobStatusBadge;
